export default function Lnb(lnbList, path, lang) {
  return (
    <>
      {
        lnbList && (<div className="menu2depthListWrap">
          <ul className="menu2depthList">
            {
              lnbList.map((item, index) => {
                const menuLink = lang == 'ko' ? item.link : item.link + '?lang=' + lang;
                return (
                  <li key={`pass-lnb-${index}`} className="menu2depth"><a href={menuLink} className={`menu2depthLink ${item.link == path ? 'current' : ''}`}>{item.title}</a></li>
                );
              })
            }
          </ul>
        </div>)
      }
    </>
  );
}